import { OLD_URL_DOMAIN, OLD_SHOP_LANGUAGES_ID } from './../constants'

export function redirectToOldShop(validLanguage) {
  window.location.assign(OLD_URL_DOMAIN + OLD_SHOP_LANGUAGES_ID[validLanguage])
}

export function redirectToShop() {
  const queryString = window.location.search
  const protocol = `${window.location.protocol}//`
  window.location.href = protocol + process.env.REACT_APP_SHOP_URL + queryString
}
